import React, { useState, useRef, useEffect } from "react";
import "../App.css";
import { useForm } from "react-hook-form";
import axios from ".././axios-interceptor";
import { base_url, BUSINESS_ROLE, COMPLIANCE_APPROVED, CRYPTO_SECRET_KEY } from "./../utilities";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import CryptoJS from 'crypto-js'
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import { PassWordExpiryModal } from "../AdminFlow/AdminLoginPage";
import { encrypt } from "../utils";
// import { decrypt } from "../encryptionUtils";
import { decrypt } from "../utils";
import Cookies from 'js-cookie';
import { colors } from "@mui/material";
import { isValidResetEmail, normalizeResetEmail, readSixDigitOtp, sanitizeOtpDigit } from "../security/password-reset-utils";

const EMPTY_OTP = {
  firstValue: '',
  secondValue: '',
  thirdValue: '',
  fourthValue: '',
  fifthValue: '',
  sixthValue: ''
};

const Business_Login = (props) => {
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);

  const handleLogin = () => { };

  // useEffect(() => {
  //   const handleResize = () => {
  //     if (window.innerWidth < 920) {
  //       alert("Access restricted to desktop devices only. Please use a desktop device to continue. 44");
  //     }
  //   };
  //   handleResize();
  //   window.addEventListener('resize', handleResize);
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []);

  const [showPWDExpModal, setShowPWDExpModal] = useState(false)


  const handlePWDExpiry=()=>{
  setShowPWDExpModal(false)
    setModalShow(true)
  }
  
  const handleCloseExpModal=()=>{
    setShowPWDExpModal(false)
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const CustomToast = ({ date }) => (
    <div>
      <div>
        Your KYC Expired on : {moment(date).format("DD-MMM-YYYY")}. 
      </div>
        <div>
          <p>Click  <a href="/kycform" className="text-primary">here</a> to fill the form.</p>
        </div>
      
    </div>
  );

 const onSubmit = (data) => {
    if (data !== null && data !== '') {
      let hashedpassword = CryptoJS.AES.encrypt(data.password, CRYPTO_SECRET_KEY).toString();
      let hashedemail = CryptoJS.AES.encrypt(data.email, CRYPTO_SECRET_KEY).toString();
      let hashedrole = CryptoJS.AES.encrypt(BUSINESS_ROLE.toString(), CRYPTO_SECRET_KEY).toString();
      axios
        .post(base_url + "loginUser", {
          email_id: hashedemail,
          password: hashedpassword,
          role: hashedrole
        })
        .then((res) => {
          if(decrypt(res.data.message)==="password expired"){
            setShowPWDExpModal(true)
          }
          const { access_token, auth_refresh_token } = res.data
          setLoginData(res.data.result);
          let data = res.data.result
          let user_id = res.data.result.user_id
          let user_name = res.data.result.user_name
          let email_id = res.data.result.email_id
          let msg=decrypt(res.data.message)
          if (msg == 'Invalid') {
            toast.error('Invalid Email or Password ', {
              toastId: 1
            })

          } 
          else if (data.role_code != BUSINESS_ROLE) {
            toast.error('Please enter valid credentials', {
              toastId: 2
            })
          }
          else {
            setDisabled(true)
            //admin session removing
            Cookies.remove("User_Accesstoken_Admin");
            Cookies.remove("User_Refreshtoken_Admin");
            // investor session removing
            Cookies.remove("User_Accesstoken_Investor");
            Cookies.remove("User_Refreshtoken_Investor");
            //creating the business session below
           Cookies.set("user_name", user_name, { expires: 7 });
            const encryptrole_code = encrypt(data.role_code, { expires: 7 });
           Cookies.set("role_code", encryptrole_code, { expires: 7 });
           Cookies.set("user_id", user_id, { expires: 7 });
           Cookies.set('User_Accesstoken', access_token, { expires: 7 })
           Cookies.set('User_Refreshtoken_Business', auth_refresh_token, { expires: 7 })
           Cookies.set('User_Accesstoken_Business', access_token, { expires: 7 })
            userSession()
            axios
            .post(base_url + "business-master/get_business_data_user", {
              user_id: Cookies.get("user_id"), 
            })
            .then((res) => {
              if(res.data.data?.kyc?.length===0 || res.data.data?.kyc[0]?.status!=COMPLIANCE_APPROVED){
                navigate('/kycform')
               Cookies.set("kyc_status", 0, { expires: 7 })
                
              }else{
                navigate('/businessdashboard')
               Cookies.set("kyc_status", 2, { expires: 7 })
                setTimeout(() => {
                  if(res.data.data?.kyc[0]?.kyc_expiry_date < new Date().getTime()){
                    toast(<CustomToast date={res.data.data?.kyc[0]?.kyc_expiry_date}/>, {
                      autoClose: 5000,
                      customId: 'custom-toast',
                    });
                  }
                }, 2000);
              }})
          }
        });
    }
  };
  const userSession = () => {
    setInterval(() => {
      axios.post(base_url + "user/refreshtoken", {
        "auth_refresh_token": Cookies.get('User_Refreshtoken_Business')
      })
        .then(res => {
         Cookies.set('User_Accesstoken_Business', res.data?.access_token, { expires: 7 })
        })
        .catch(err => {
          console.log(err);
        })
      }, 50 * 60 * 1000);
    }
    
  return (
    <div className="my-4">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group mb-3 ">
          <label htmlFor="email">
            Email<span className="">*</span>
          </label>
          <input
            {...register("email", { required: true })}
            id="email"
            type="text"
            className="form-control rounded px-4 py-3 border-0"
            placeholder="Please enter your Email"
          />
          {errors.email && (
            <span style={{ color: "#fd5a5a" }}>Please enter an Email </span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="password">
            Password<span className="">*</span>
          </label>
          <input
            {...register("password", { required: true })}
            id="password"
            type="password"
            className="form-control rounded px-4 py-3 border-0"
            placeholder="Please enter your password"
          />
          <div className="d-flex justify-content-between">
            {errors.password && (
              <span style={{ color: "#fd5a5a" }}>Enter a password </span>
            )}
            <span className="forgot_pwd" onClick={() => setModalShow(true)}>
              Reset Password?
            </span>
          </div>
        </div>


        <ResetPassword modalShow={modalShow} setModalShow={setModalShow} />
        <PassWordExpiryModal 
showPWDExpModal={showPWDExpModal}
 handleCloseExpModal={handleCloseExpModal} 
 handlePWDExpiry={handlePWDExpiry}

        />

        <div className="d-grid">
          <button
            className="btn blue_btn mt-5 fw-bolder"
            disabled={disabled}
            onClick={handleLogin}
          >
            Login
          </button>
        </div>
      </form>
    </div>
  );
};

export default Business_Login;

export const ResetPassword = (props) => {

  let setModalShow = props.setModalShow
  let modalShow = props.modalShow

  const firstInputRef = useRef(null);
  const secondInputRef = useRef(null);
  const thirdInputRef = useRef(null);
  const fourthInputRef = useRef(null);
  const fifthInputRef = useRef(null);
  const sixthInputRef = useRef(null);
  const verificationTransitionRef = useRef(null);
  const resetFlowGenerationRef = useRef(0);

  const [otpValue, setOtpValues] = useState(EMPTY_OTP);
  const otpFieldNames = Object.keys(EMPTY_OTP);
  const otpInputRefs = [firstInputRef, secondInputRef, thirdInputRef, fourthInputRef, fifthInputRef, sixthInputRef];
  const handleInput = (event, inputRef, prevInputRef) => {
    const input = event.target;
    const digit = sanitizeOtpDigit(input.value);
    if (digit === "" || /^\d$/.test(digit)) {
      if (prevInputRef && digit === "") {
        prevInputRef.current.focus();
      } else if (inputRef && inputRef.current !== firstInputRef.current) {
        inputRef.current.focus();
      }
      setOtpValues((prevValues) => ({
        ...prevValues,
        [input.name]: digit
      }));
    }
  };

  const handleOtpPaste = (event) => {
    const pastedDigits = readSixDigitOtp(event.clipboardData.getData('text'));
    if (!pastedDigits) return;
    event.preventDefault();
    setOtpValues(otpFieldNames.reduce((values, fieldName, index) => ({
      ...values,
      [fieldName]: pastedDigits[index]
    }), {}));
    otpInputRefs[pastedDigits.length - 1].current?.focus();
  };

  const handleOtpKeyDown = (event, previousInputRef) => {
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (event.key === 'Backspace' && event.target.value === '' && previousInputRef) {
      previousInputRef.current?.focus();
    }
    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  };



  const [verificationCodeModalShow, setVerificationCodeModalShow] = React.useState(false);
  const [newPasswordModalShow, setNewPasswordModalShow] = React.useState(false);
  const [isRequestingOtp, setIsRequestingOtp] = React.useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = React.useState(false);
  const [isUpdatingPassword, setIsUpdatingPassword] = React.useState(false);
  const handleCloseVerificationCode = () => {
    resetFlowGenerationRef.current += 1;
    if (verificationTransitionRef.current) {
      clearTimeout(verificationTransitionRef.current);
      verificationTransitionRef.current = null;
    }
    setEmail('');
    setOtpValues(EMPTY_OTP);
    setResetToken('');
    setIsVerifyingOtp(false);
    setVerificationCodeModalShow(false)
  };
  const handleCloseNewPassword = () => {
    resetFlowGenerationRef.current += 1;
    if (verificationTransitionRef.current) {
      clearTimeout(verificationTransitionRef.current);
      verificationTransitionRef.current = null;
    }
    setNewPasswordModalShow(false)
    setEmail('');
    setOtpValues(EMPTY_OTP);
    setResetToken('');
    setEnterPassword('');
    setConfirmPwd('');
    setIsPasswordValid(false);
    setIsUpdatingPassword(false);
    setError('');
  };


  // const firstCloseSecondOpen = () => {
  //   setMinutes(1);
  //   setSeconds(59);
  //   if (email !== '') {
  //   let encryptedEmail = CryptoJS.AES.encrypt(email, CRYPTO_SECRET_KEY).toString();

  //     axios
  //       .post(base_url + "user/reset_password", {
  //         "email_id": encryptedEmail
  //       })
  //       .then((res) => {
  //         if (decrypt(res.data.message) == "The verification code has been sent") {
  //           toast.success("The verification code has been sent", {
  //             toastId: 19
  //           })
  //           setModalShow(false)
  //           setVerificationCodeModalShow(true)
  //         }
  //         else {
  //           toast.error('Invalid email', {
  //             toastId: 15
  //           })
  //         }

  //       })
  //   }
  // }

  const firstCloseSecondOpen = () => {
  if (isRequestingOtp) return;
  setMinutes(1);
  setSeconds(0);

  const normalizedEmail = normalizeResetEmail(email);
  if (isValidResetEmail(normalizedEmail)) {
    const flowGeneration = resetFlowGenerationRef.current;
    setIsRequestingOtp(true);
    setEmail(normalizedEmail);
    let encryptedEmail = CryptoJS.AES.encrypt(normalizedEmail, CRYPTO_SECRET_KEY).toString();

    axios
      .post(base_url + "user/reset_password", {
        email_id: encryptedEmail,
      })
      .then((res) => {
        if (flowGeneration !== resetFlowGenerationRef.current) return;
        let decryptedMessage = "";

        try {
          decryptedMessage = decrypt(res.data.message);
        } catch (e) {
          decryptedMessage = res.data.message;
        }

        if (decryptedMessage === "The verification code has been sent") {
          toast.success("The verification code has been sent", {
            toastId: 19,
          });

          setModalShow(false);
          setVerificationCodeModalShow(true);
        }

        // ❌ DO NOTHING for invalid email (no toast)
      })
      .catch((err) => {
        if (flowGeneration !== resetFlowGenerationRef.current) return;
        console.error("Reset password error:", err);
      })
      .finally(() => {
        if (flowGeneration === resetFlowGenerationRef.current) {
          setIsRequestingOtp(false);
        }
      });
  } else {
    toast.error('Please enter a valid email address', {
      toastId: 15,
    });
  }
};
  const secondCloseThirdOpen = () => {
    if (isVerifyingOtp) return;

    let final_verfication_code = (otpValue.firstValue) + (otpValue.secondValue) + (otpValue.thirdValue) + (otpValue.fourthValue)+ (otpValue.fifthValue)+ (otpValue.sixthValue)
    if (!/^\d{6}$/.test(final_verfication_code)) return;
    const flowGeneration = resetFlowGenerationRef.current;
    setIsVerifyingOtp(true);
    let encryptedOTP = CryptoJS.AES.encrypt(final_verfication_code, CRYPTO_SECRET_KEY).toString();
    let encryptedEmail = CryptoJS.AES.encrypt(email, CRYPTO_SECRET_KEY).toString();
    axios
      .post(base_url + "user/verify/code", {
        "verification_code": encryptedOTP,
        "email_id": encryptedEmail
      })
      .then((res) => {
        if (flowGeneration !== resetFlowGenerationRef.current) return;
        if (decrypt(res.data.message) === "Verified" && res.data.reset_token) {
          setResetToken(res.data.reset_token)
          verificationTransitionRef.current = setTimeout(() => {
            if (flowGeneration !== resetFlowGenerationRef.current) return;
            setVerificationCodeModalShow(false)
            setNewPasswordModalShow(true)
            verificationTransitionRef.current = null;
          }, 1000);
          toast.success("Successfully verified", {
            toastId: 18
          })
        }
        else {
          toast.error("Invalid verification code", {
            toastId: 4
          })
        }
      })
      .catch(() => {
        // The shared interceptor already displayed the provider/API error.
      })
      .finally(() => {
        if (flowGeneration === resetFlowGenerationRef.current) {
          setIsVerifyingOtp(false);
        }
      });
  }
  const [resetToken, setResetToken] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [enterPassword, setEnterPassword] = useState('')
  const [confirmPwd, setConfirmPwd] = useState('')
  const [isPasswordValid, setIsPasswordValid] = useState(false);

  const handleChangePassword = (e) => {
    let value = e.target.value;
    let name = e.target.name;
  
    if (name === "password") {
      if (value !== '' || value !== undefined) { 
        const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+~\-={}\[\]|\\:;"'<>,.?/]).{8,}$/;
        if (regex.test(value)) {
          setEnterPassword(value) 
          setError(""); 
          setIsPasswordValid(true); 
        }else {
          setError("Password does not meet the criteria.");
          setIsPasswordValid(false);
        }
      }
    }
    if (name === "confirmpassword") {
      if (value !== '' || value !== undefined) { setConfirmPwd(value) }

      if (enterPassword && value !== enterPassword) {
        setError("Passwords do not match.");
      } else {
        setError(""); 
      }
      
    }
  }

  // const handleConfirmPasswordChange = (event) => {

  //   setConfirmPassword(event.target.value);
  // }
  const handleToggleShowPassword = () => {
    setShowPassword(!showPassword);
  }

  const [email, setEmail] = useState('');

  const handleEmailChange = (e) => {
    setEmail(e.target.value);

  };

  const handlePwdSuccess = (event) => {
    event.preventDefault();
    if (isUpdatingPassword) return;
    if (!isPasswordValid || enterPassword !== confirmPwd) {
      setError('Passwords do not match');
    }
    else {
    const flowGeneration = resetFlowGenerationRef.current;
    setIsUpdatingPassword(true);
    let encryptedEmail = CryptoJS.AES.encrypt(email, CRYPTO_SECRET_KEY).toString();
    let encryptedPWD = CryptoJS.AES.encrypt(enterPassword, CRYPTO_SECRET_KEY).toString();

      axios
        .post(base_url + "user/password/update", {
          "email_id": encryptedEmail,
          "password": encryptedPWD,
          "reset_token": resetToken
        })
        .then((res) => {
          if (flowGeneration !== resetFlowGenerationRef.current) return;
          if (res.data.message === "Successfully updated") {
            setResetToken('')
            handleCloseNewPassword()
            toast.success("Successfully updated", {
              toastId: 4
            }) 
            setTimeout(() => {
              window.location.reload()
            }, 800);
          }
          else if (res.data.message === "Please don't use a previous password which is already used before") {
            toast.error("New password must not match any of the previous passwords", {
             
            }) 
          }
          else {
            toast.error("error occured try after sometime", {
              toastId: 4
            })
            handleCloseNewPassword()
          }
        })
        .catch(() => {
          // The shared interceptor already displayed the provider/API error.
        })
        .finally(() => {
          if (flowGeneration === resetFlowGenerationRef.current) {
            setIsUpdatingPassword(false);
          }
        });
    }
  }



  const handleClose = () => {
    resetFlowGenerationRef.current += 1;
    setEmail('')
    setIsRequestingOtp(false)
    setModalShow(false)
    if (modalShow === false) {
      setEmail('')
    }
  };

  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (seconds === 0 && minutes === 0) return undefined;
    const interval = setTimeout(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearTimeout(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearTimeout(interval);
    };
  }, [minutes, seconds]);

  useEffect(() => () => {
    resetFlowGenerationRef.current += 1;
    if (verificationTransitionRef.current) {
      clearTimeout(verificationTransitionRef.current);
    }
  }, []);



  return (
    <div>

      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        keyboard={false}
        className=""
        show={modalShow}
        onHide={handleClose}
      >
        <Modal.Body className="forgot_pwd_main">
          <h5 >Reset Password</h5>
          <p>Verification code will be sent to your registered email ID</p>
          <Form>
            <Form.Group className="mb-3 mt-4" controlId="exampleForm.ControlInput1">
              <Form.Label>Email </Form.Label>
              <Form.Control className="input_email" type="email" autoFocus placeholder="Enter your email " value={email}
                onChange={handleEmailChange} />
            </Form.Group>
          </Form>
          <button type="button" onClick={firstCloseSecondOpen} className=" reset_btn mt-3" disabled={!isValidResetEmail(email) || isRequestingOtp}><div className="reset_txt" >Reset Password</div></button>


          <div className="sesam_color_backto w-50 m-auto mt-4" onClick={handleClose}><img src="./images/sesameleftarrow.svg" alt="" /> Back to login</div>
        </Modal.Body>
      </Modal>


      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        className=""
        show={verificationCodeModalShow}
        onHide={handleCloseVerificationCode}
      >

        <i
          className="fa-sharp fa-solid fa-xmark new_password_crossmark"
          role="button"
          tabIndex={0}
          aria-label="Close verification code"
          onClick={handleCloseVerificationCode}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') handleCloseVerificationCode();
          }}
        ></i>
        <Modal.Body className="forgot_pwd_main">
          <h5 >Enter Verification Code</h5>
          <p>Enter 6 digit code that you received on your email ID</p>

          <div className="d-flex opt_field_boxes" onPaste={handleOtpPaste}>
            <input
              type="text"
              inputMode="numeric"
              aria-label="Verification code digit 1"
              maxLength={1}
              name="firstValue"
              value={otpValue.firstValue}
              autoFocus
              ref={firstInputRef}
              onChange={(e) => handleInput(e, secondInputRef, firstInputRef)}
              onKeyDown={(e) => handleOtpKeyDown(e, null)}
            />
            <input
              type="text"
              inputMode="numeric"
              aria-label="Verification code digit 2"
              maxLength={1}
              name="secondValue"
              value={otpValue.secondValue}
              ref={secondInputRef}
              onChange={(e) => handleInput(e, thirdInputRef, firstInputRef)}
              onKeyDown={(e) => handleOtpKeyDown(e, firstInputRef)}
            />
            <input
              type="text"
              inputMode="numeric"
              aria-label="Verification code digit 3"
              maxLength={1}
              name="thirdValue"
              value={otpValue.thirdValue}
              ref={thirdInputRef}
              onChange={(e) => handleInput(e, fourthInputRef, secondInputRef)}
              onKeyDown={(e) => handleOtpKeyDown(e, secondInputRef)}
            />
            <input
              type="text"
              inputMode="numeric"
              aria-label="Verification code digit 4"
              maxLength={1}
              name="fourthValue"
              value={otpValue.fourthValue}
              ref={fourthInputRef}
              onChange={(e) => handleInput(e, fifthInputRef, thirdInputRef)}
              onKeyDown={(e) => handleOtpKeyDown(e, thirdInputRef)}
            />
            <input
              type="text"
              inputMode="numeric"
              aria-label="Verification code digit 5"
              maxLength={1}
              name="fifthValue"
              value={otpValue.fifthValue}
              ref={fifthInputRef}
              onChange={(e) => handleInput(e, sixthInputRef, fourthInputRef)}
              onKeyDown={(e) => handleOtpKeyDown(e, fourthInputRef)}
            />
            <input
              type="text"
              inputMode="numeric"
              aria-label="Verification code digit 6"
              maxLength={1}
              name="sixthValue"
              value={otpValue.sixthValue}
              ref={sixthInputRef}
              onKeyDown={(e) => handleOtpKeyDown(e, fifthInputRef)}
              onChange={(e) => {
                handleInput(e, null, fifthInputRef);
              }}
            />
          </div>

          <div className="resend_main">
            <div className="resend_otp_txt">If you didn’t receive a code<button className="resend_style" style={{
                color: seconds > 0 || minutes > 0 ? "#DFE3E8" : ""
              }} disabled={seconds > 0 || minutes > 0 || isRequestingOtp} onClick={firstCloseSecondOpen}>Resend</button></div>
            <div>
              {seconds > 0 || minutes > 0 ? (
                <p>
                  Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </p>
              ) : (
                <p>Didn't recieve code?</p>
              )}
            </div>
          </div>
          <div className="m-auto d-flex justify-content-center"><button className="reset_btn w-50 " onClick={secondCloseThirdOpen}
            disabled={isVerifyingOtp || !(otpValue.firstValue !== '' && otpValue.secondValue !== '' && otpValue.thirdValue !== '' && otpValue.fourthValue !== '' && otpValue.fifthValue !== '' && otpValue.sixthValue !== '')}
          >
            Submit</button></div>

        </Modal.Body>

      </Modal>


      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        className="reset_third_modal"
        show={newPasswordModalShow}
        onHide={handleCloseNewPassword}
      >


        <i
          className="fa-sharp fa-solid fa-xmark new_password_crossmark"
          role="button"
          tabIndex={0}
          aria-label="Close new password"
          onClick={handleCloseNewPassword}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') handleCloseNewPassword();
          }}
        ></i>
        <Modal.Body className="forgot_pwd_main" style={{ height: "340px" }} >
          <Form >
            <Form.Group className="mb-3 " controlId="passwordInput">
              <Form.Label>Enter new password</Form.Label>
              <Form.Control className="input_email" type={showPassword ? 'text' : 'password'} name="password" placeholder="Password"  onChange={handleChangePassword} />
            </Form.Group>
            <Form.Group className="mt-3" controlId="confirmPasswordInput">
              <Form.Label>Confirm password</Form.Label>
              <div className="confirm_pwd_hide_icon">
                <Form.Control className="input_email" type={showPassword ? 'text' : 'password'} name="confirmpassword" 
                placeholder="Confirm password" 
                disabled={!isPasswordValid} 
                onChange={handleChangePassword} />
                <img src="./images/hidepassword.svg" alt="" className="hide_pwd_icon mb-1" onClick={handleToggleShowPassword} />
              </div>
            </Form.Group>
            <p></p>
            {error && <span className="text-danger " >{error}</span>}
            <div className='reset_password_const '>
            <span className="passwd_crit_reset">The password should meet the following criteria:</span>
            <ul>
              <li>should be at least 8 characters long</li>
              <li>contain at least 1 number.</li>
              <li>contain at least 1 uppercase character.</li>
              <li>contain at least 1 lowercase character.</li>
              <li>contain at least 1 symbol.</li>
            </ul>

            </div>
            {/* <div>{error && <p className="text-danger">{error}</p>}</div> */}
            <div className="newpswd_btn_styl"><button className=" blue_btn w-50" 
            // disabled={enterPassword !== '' && enterPassword === confirmPwd ? false : true}
            disabled={isUpdatingPassword || !enterPassword || enterPassword !== confirmPwd}
             onClick={handlePwdSuccess}>Submit</button></div>

          </Form>


        </Modal.Body>

      </Modal>

    </div>
  );
};
